'use es6';

export const UNIQUE_PROPERTIES_BY_OBJECT_TYPE = {};
export const UNIQUE_PROPERTIES_FOR_ANY_OBJECT_TYPE = ['hs_object_id'];